import {
  Card,
  CardCaption,
  CardTitle,
  EducationScreen,
  FDARow,
  Gold,
  Registered,
  RevealBlock,
  ScreenBody,
  ScreenIntro,
  ScreenSubhead,
} from './EducationShell';
import {FamilyTreeViz, MechanismChainViz, type FamilyTreeItem} from './Step9Viz';
import {ZepboundDisclaimer} from './ZepboundDisclaimer';

const ITEMS: FamilyTreeItem[] = [
  {name: 'Ozempic', indication: 'Type 2 diabetes'},
  {name: 'Wegovy', indication: 'Chronic weight management'},
  {name: 'Mounjaro', indication: 'Type 2 diabetes'},
  {
    name: (
      <>
        Zepbound
        <Registered size={9} />
      </>
    ),
    indication: 'Severe sleep apnea',
  },
];

/** Step 9 — branded. Frames Zepbound inside the broader GLP-1 family,
 *  then explains the airway-pressure mechanism. */
export const Glp1EducationFamilyBranded = () => (
  <EducationScreen
    ctaLabel="Next"
    variant="branded_v1"
    analyticsShown="GLP-1 Funnel Education Family Viewed"
    analyticsSubmitted="GLP-1 Funnel Education Family Continue Tapped"
  >
    <ScreenIntro
      headline={
        <>
          Zepbound
          <Registered /> is the only GLP-1 approved for <Gold>severe sleep apnea</Gold>.
        </>
      }
      subhead="Same medication class but the only one that treats apnea, not just weight."
    />

    <RevealBlock delayMs={300}>
      <Card>
        <CardTitle>
          One family. <Gold>Different conditions.</Gold>
        </CardTitle>
        <FamilyTreeViz items={ITEMS} highlightedIdx={3} delayMs={200} />
        <CardCaption>
          These get talked about as one thing in the news. The FDA approves each one separately, for a specific
          condition. Yours is for severe sleep apnea.
        </CardCaption>
      </Card>
    </RevealBlock>

    <RevealBlock delayMs={500}>
      <FDARow text="Approved by the FDA in December 2024 · Studied in the SURMOUNT-OSA trial" />
    </RevealBlock>

    <RevealBlock delayMs={300}>
      <Card>
        <CardTitle>
          Less pressure on your airway. <Gold>Fewer collapses.</Gold>
        </CardTitle>
        <MechanismChainViz delayMs={200} />
        <CardCaption>
          Extra weight presses on your airway during sleep. Zepbound
          <Registered size={9} /> reduces that pressure. The sleep interruptions drop with it.
        </CardCaption>
      </Card>
    </RevealBlock>

    <RevealBlock delayMs={500}>
      <ScreenSubhead>About the weight loss.</ScreenSubhead>
      <ScreenBody>
        Most people lose weight along the way, which is part of how the medication works. GLP-1 medications also bring
        other benefits: better cardiovascular health, more stable blood sugar, less inflammation. Your sleep is the
        primary target. The rest is bonus.
      </ScreenBody>
    </RevealBlock>

    <RevealBlock delayMs={500}>
      <ZepboundDisclaimer />
    </RevealBlock>
  </EducationScreen>
);

export default Glp1EducationFamilyBranded;
